export class SelectOptionView {
    value: string;
    label: string;
    constructor(data?: any) {
        this.value = data?.value.toString() ?? "";
        this.label = data?.label ?? "";
    }
}
